import { clsx } from "clsx";

interface Tab<T extends string> {
  id: T;
  label: string;
}

interface TabsProps<T extends string> {
  tabs: Tab<T>[];
  activeTab: T;
  onTabChange: (tab: T) => void;
  className?: string;
}

const baseTabClasses = "btn-custom px-4 py-2 font-medium transition-colors bg-transparent";
const activeTabClasses = "border-b-2 border-dobu-orange text-dobu-orange";
const inactiveTabClasses = "text-gray-500 hover:text-gray-700";

function Tabs<T extends string>({ tabs, activeTab, onTabChange, className }: TabsProps<T>) {
  return (
    <div className={clsx("flex border-b border-gray-200", className)}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={clsx(baseTabClasses, activeTab === tab.id ? activeTabClasses : inactiveTabClasses)}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

export default Tabs;
